import React, {useState} from "react";
import { Box, Typography } from "@mui/material";
import BaseModal from "../BaseModal/BaseModal";
import ModalFooter from "../ModalFooter/ModalFooter";
import InfoIconRed from "../../../../../asset/image/red-info-icon.svg";
import InfoIcon from '../../../../../asset/image/new_Info_Icon.svg';
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

interface CommonModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  title: string;
  saveText?: string;
  cancelText?: string;
  height?: string;
  width?: string;
  maxWidth?: string;
  children: React.ReactNode;
  disableSave?: boolean;
  titleWithDeleteIcon?: boolean; 
  showOnlineOffline?: boolean;
  showSyncStatus?: boolean;
  titleWithWarningIcon?: boolean;
  showCancel?: boolean;
  titleWithCustomIcon?: boolean;
  customIcon?: any;
  editableTitle?: boolean;
  titleValue?: string;
  handleTitleChange?: (e: any) => void;
  onCancelSave?: () => void;
  syncProps?: {
    showSyncIcon: boolean,
    onSyncClick: () => void,
    isSyncing: boolean,
    setIsSyncing: React.Dispatch<React.SetStateAction<boolean>>;
  };
  showLoader?: boolean;
}

const CommonModal: React.FC<CommonModalProps> = ({
  open,
  onClose,
  onSave,
  title,
  saveText = "Save",
  cancelText = "Cancel",
  height,
  width,
  maxWidth,
  children,
  disableSave,
  titleWithDeleteIcon = false, 
  showOnlineOffline,
  showSyncStatus,
  titleWithWarningIcon,
  showCancel = true,
  titleWithCustomIcon,
  customIcon,
  editableTitle,
  titleValue,
  handleTitleChange,
  onCancelSave,
  syncProps,
  showLoader=false
}) => {
  const [isRenaming, setIsRenaming] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={(titleWithDeleteIcon || titleWithWarningIcon || titleWithCustomIcon) ? "" : title}
      rawTitleOnly
      width={width || "700px"}
      maxWidth={maxWidth || "640px"}
      height={height || "auto"}
      showOnlineOffline={showOnlineOffline}
      showSyncStatus={showSyncStatus}
      syncProps={syncProps}
      titleComponent={
        titleWithDeleteIcon ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              component="img"
              src={InfoIconRed}
              alt="info"
              sx={{ width: 20, height: 20 }}
            />
            <Box
              component="span"
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "14px",
                color: "#3A3C4A",
              }}
            >
              {title}
            </Box>
          </Box>
        ) : 
        titleWithWarningIcon ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              component="img"
              src={InfoIcon}
              alt="info"
              sx={{ width: 20, height: 20 }}
            />
            <Box
              component="span"
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "14px",
                color: "#3A3C4A",
              }}
            >
              {title}
            </Box>
          </Box>
        ) : titleWithCustomIcon ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              component="img"
              src={customIcon}
              alt="info"
              sx={{ width: 20, height: 20 }}
            />
            <Box
              component="span"
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "14px",
                color: "#3A3C4A",
              }}
            >
              {title}
            </Box>
          </Box>) : editableTitle ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              component="span"
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "14px",
                color: "#3A3C4A",
              }}
            >
              {title}
            </Box>
            <Box>
              {!isRenaming ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRadius: "8px",
                      padding: "6px 12px",
                    }}
                  >
                    
                    <Typography
                      sx={{ fontWeight: 500, flex: 1, fontSize: "14px", color: "#0F172A" }}
                    >
                      {titleValue}
                    </Typography>

                    <EditIcon
                      onClick={() => {
                        setIsRenaming(true);
                        
                      }}
                      style={{
                        width: 16,
                        height: 16,
                        cursor: "pointer",
                        marginLeft: 8,
                        color: "#6B7280",
                      }}
                    />
                  </Box>
                ) : (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #D1D5DB",
                        borderRadius: "4px",
                        padding: "6px 10px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <input
                        type="text"
                        value={titleValue}
                        autoFocus
                        onChange={handleTitleChange}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#0F172A",
                        }}
                      />
                      <CheckIcon
                        onClick={() => {
                          if (saveDisabled) return;
                          setIsRenaming(false);
                        }}
                        style={{
                          width: 18,
                          height: 18,
                          cursor:  "pointer",
                          color: "#6B7280",
                          marginLeft: 8,
                          pointerEvents: saveDisabled ? "none" : "auto",
                        }}
                      />

                      {/* Cancel (✖) */}
                      <CloseIcon
                        onClick={() => { setIsRenaming(false); setSaveDisabled(false) }}
                        style={{
                          width: 18,
                          height: 18,
                          cursor: "pointer",
                          color: "#6B7280",
                          marginLeft: 6,
                        }}
                      />
                    </Box>
                    
                  </>
                )}
            </Box>
          </Box>
          ) : undefined
      }
      showLoader={showLoader}
    >
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}

        <ModalFooter
  onClose={() => {
    console.log("⛳ Cancel clicked");
    if(cancelText != 'Cancel') {
      onCancelSave?.()
    } else {
      onClose();
    }
  }}
  onSave={() => {
    console.log("🔥 Save button clicked directly in CommonModal");
    onSave();
  }}
  cancelText={cancelText}
  saveText={saveText}
  disableSave={disableSave}
  showCancel={showCancel}
/>

      </Box>
    </BaseModal>
  );
};

export default CommonModal;
